import { useLocation } from 'react-router-dom';
import { Image, Text } from '@belong/ui';
import queryString from 'query-string';
import { HOMEOWNER_ONBOARDING_STRINGS } from 'strings/homeowner-onboarding.strings';

export function ConnectNowBanner() {
  const location = useLocation();

  const { connect } = queryString.parse(location.search);
  const connectParamBoolean = connect === 'true';

  if (!connectParamBoolean) {
    return null;
  }

  return (
    <div className="mb-xl pt-sm">
      <div className="flex flex-col gap-sm rounded border border-solid border-green bg-green-translucent-light p-sm sm:flex-row">
        <Image
          alt="Support"
          src="homeowners/sign-up/support.svg"
          className="mx-auto h-3xl w-3xl sm:mx-0 sm:my-auto sm:h-2xl sm:w-2xl"
        />
        <div className="flex flex-col gap-xs">
          <Text fontWeight="semibold">
            {HOMEOWNER_ONBOARDING_STRINGS.PropertyBasics.preQualificationTitle}
          </Text>
          <Text variant="p1">
            {
              HOMEOWNER_ONBOARDING_STRINGS.PropertyBasics
                .preQualificationSubtitle
            }
          </Text>
        </div>
      </div>
    </div>
  );
}
